import React from 'react';
import { Select } from '../ui/Select';
import { Input } from '../ui/Input';
interface BankFieldsProps {
  bankNameId: string;
  bankBranchId: string;
  bankAccountNo: string;
  onBankNameChange: (value: string) => void;
  onBankBranchChange: (value: string) => void;
  onBankAccountNoChange: (value: string) => void;
  errors?: {
    bankNameId?: string;
    bankBranchId?: string;
    bankAccountNo?: string;
  };
}
export function BankFields({
  bankNameId,
  bankBranchId,
  bankAccountNo,
  onBankNameChange,
  onBankBranchChange,
  onBankAccountNoChange,
  errors
}: BankFieldsProps) {
  // Mock bank data
  const banks = [{
    value: 'bank1',
    label: 'Premier Bank'
  }, {
    value: 'bank2',
    label: 'Dahabshiil Bank'
  }, {
    value: 'bank3',
    label: 'Salaam Bank'
  }];
  const bankBranches = [{
    value: 'branch1',
    label: 'Main Branch'
  }, {
    value: 'branch2',
    label: 'Hargeisa Branch'
  }, {
    value: 'branch3',
    label: 'Mogadishu Branch'
  }];
  return <div className="space-y-4 p-4 bg-blue-50 border border-blue-200 rounded-md" data-id="element-81">
      <h4 className="text-sm font-medium text-blue-900" data-id="element-82">
        Bank Account Details
      </h4>

      <Select label="Bank Name" required options={banks} value={bankNameId} onChange={e => onBankNameChange(e.target.value)} error={errors?.bankNameId} data-id="element-83" />

      <Select label="Bank Branch" required options={bankBranches} value={bankBranchId} onChange={e => onBankBranchChange(e.target.value)} error={errors?.bankBranchId} data-id="element-84" />

      <Input label="Account Number" required value={bankAccountNo} onChange={e => onBankAccountNoChange(e.target.value)} error={errors?.bankAccountNo} placeholder="Enter bank account number" data-id="element-85" />
    </div>;
}